const dateFormat = 'MMM DD, YYYY';
const dateAndTimeFormat = 'MMM DD, YYYY h:mm a';
const yyyymmddhhmmss = 'YYYY-MM-DD HH:mm:ss';
const DMYFormatWithHyphen = 'DD-MM-YYYY';
const XlsType = 'application/vnd.ms-excel';
const XlsWpsType = 'application/wps-office.xls';
const XlsxType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CsvType = 'text/csv';
const JsType = 'text/javascript';
const pythonDjangoType = 'text/x-python';
const DmnType = 'dmn';
const success = 'success';
const info = 'info';
const warning = 'warning';
const error = 'error';
const year = 'YYYY';
const payoutTypes = [
  { value: 'percentage', label: 'Percentage' },
  {
    value: 'percentage_min_fixed_max_variable',
    label: 'Percentage with Min-Fixed & Max-Variable',
  },
  {
    value: 'percentage_min_fixed_max_fixed',
    label: 'Percentage with Min-Fixed & Max-Fixed',
  },
  {
    value: 'percentage_min_variable_max_variable',
    label: 'Percentage with Min-Variable & Max-Variable',
  },
  {
    value: 'percentage_min_variable_max_fixed',
    label: 'Percentage with Min-Variable & Max-Fixed',
  },
  { value: 'percentage_min_fixed', label: 'Percentage with Min-Fixed' },
  { value: 'percentage_min_variable', label: 'Percentage with Min-Variable' },
  { value: 'percentage_max_fixed', label: 'Percentage with Max-Fixed' },
  { value: 'percentage_max_variable', label: 'Percentage with Max-Variable' },
  { value: 'flat', label: 'Flat' },
  {
    value: 'flat_min_variable_max_fixed',
    label: 'Flat with Min-Variable & Max-Fixed',
  },
  {
    value: 'flat_min_variable_max_variable',
    label: 'Flat with Min-Variable & Max-Variable',
  },
  {
    value: 'flat_min_fixed_max_fixed',
    label: 'Flat with Min-Fixed & Max-Fixed',
  },
  {
    value: 'flat_min_fixed_max_variable',
    label: 'Flat with Min-Fixed & Max-Variable',
  },
  { value: 'flat_max_fixed', label: 'Flat with Max-Fixed' },
  { value: 'flat_max_variable', label: 'Flat with Max-Variable' },
  { value: 'flat_min_fixed', label: 'Flat with Min-Fixed' },
  { value: 'flat_min_variable', label: 'Flat with Min-Variable' },
];
const png = 'png';
const jpeg = 'jpeg';
const jpg = 'jpg';
const pdf = 'pdf';
const tiff = 'tiff';
const tif = 'tif';
const OtherXlsx =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const JsonType = 'application/json';
const imageFallback =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';
const reviewer = 'reviewer';
const approver = 'approver';
const lockedDefaultQueryNames = [
  'Contract not mapped (Remapping)',
  'Exceptional Approval-Incentive Target not achieved',
];
const defaultQueryDescription = 'date';

const common = 'COMMON';
const user = 'user';
const show = 'Show';
const constants = {
  dateFormat,
  DMYFormatWithHyphen,
  yyyymmddhhmmss,
  XlsType,
  XlsWpsType,
  XlsxType,
  CsvType,
  JsType,
  pythonDjangoType,
  DmnType,
  success,
  info,
  warning,
  error,
  year,
  payoutTypes,
  png,
  jpeg,
  jpg,
  pdf,
  tiff,
  tif,
  OtherXlsx,
  JsonType,
  imageFallback,
  reviewer,
  approver,
  dateAndTimeFormat,
  lockedDefaultQueryNames,
  defaultQueryDescription,
  common,
  user,
  show,
};

export default constants;
